import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectCreative } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import missionImage from "../../assets/mission-image.jpg";
import visionImage from "../../assets/vision-image.jpg";
import "./missionAndVision.css";

const MissionAndVision = () => {
  return (
    <div className="mission-vision-wrapper">
      <Swiper
        slidesPerView={1}
        spaceBetween={10}
        // navigation={true}
        speed={1000}
        grabCursor={true}
        effect={"creative"}
        loop={true}
        creativeEffect={{
          prev: {
            shadow: true,
            translate: [0, 0, -400],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        }}
        modules={[Autoplay, Pagination, EffectCreative]}
        className="mySwiper"
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          dynamicBullets: true,
          clickable: true,
        }}
      >
        <SwiperSlide>
          <div className="d-flex mission-vision-details">
            <div className="tex-wrapper">
              <h2>
                Our <span>Mission</span>
              </h2>
              <p className="fs-lead my-4">
                Empowering Global Innovation with Tailored Software Solutions
              </p>
              <p className="my-4">
                Our mission at Soori Technology is to deliver innovative and
                reliable software solutions that drive transformation and
                efficiency across diverse industries worldwide. We are dedicated
                to understanding our clients' unique challenges and providing
                tailored technology that enhances their business performance and
                fosters sustainable growth.
              </p>
            </div>
            <div className="image-container">
              <img src={missionImage} alt="mission" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="d-flex mission-vision-details">
            <div className="tex-wrapper">
              <h2>
                Our <span>Vision</span>
              </h2>
              <p className="fs-lead my-4">
                Leading the Future of Technology: Inspiring Global Growth and
                Efficiency
              </p>
              <p className="my-4">
                Our vision is to be a global leader in software technology,
                recognized for our commitment to excellence and innovation. We
                aspire to empower businesses around the world with cutting-edge
                solutions that address complex challenges, inspire progress, and
                create lasting value. Through continuous advancement and a
                customer-centric approach, we aim to set new standards in the
                technology industry and contribute to a more connected and
                efficient global marketplace.
              </p>
            </div>
            <div className="image-container">
              <img src={visionImage} alt="mission" />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default MissionAndVision;
